<template>
    <div class="footerslide">

    </div>
</template>

<script>
export default {
    data(){
        return {

        }
    },
    computed:{

    },
    props:{

    },
    methods:{

    }
}
</script>

<style lang="scss" scoped>
    .footerslide{
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background: url('../assets/loginfooter.png') center center no-repeat;
        height: 49px;
        background-size: 100% 49px;
        background-color: #fff;
        z-index: 2;
        @media screen and (max-width: 992px){
            height: 3.2vh;
            background-size: 100% 100%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/footerSlide.vue